
































import { Component, Vue } from "vue-property-decorator"
// import BeatBeat from "beat-beat-js"
import BeatBeat from "../../../src/beat-beat"

@Component
export default class Plant extends Vue {

	isLoading = true

	private sound: BeatBeat = new BeatBeat("/sounds/Pional-Casualty.mp3")

	private isTick: boolean = false
	private time: number = 0


	get plantClass() {
		return this.isTick ? "animated" : ""
	}

	get plantStyle() {
		return { transition: `all ${ this.time }s ease-in-out`}
	}

	get leafStyle() {
		return { transform: `rotateZ(${ 6 * (this.isTick ? -1 : 1) }deg)` }
	}

	get leafStyleSm() {
		return { transform: `rotateZ(${ 6 * (this.isTick ? 1 : -1) }deg)` }
	}

	get circleClass() {
		return { beat: this.isTick }
	}

	async mounted() {
		await this.sound.load()
		this.isLoading = false
	}

	play() {
		this.sound.play(this.onAnimate.bind(this))
	}

	destroyed() {
		this.sound.destroy()
	}

	private onAnimate(time: number) {
		this.time = time
		this.isTick = !this.isTick
	}
}
